<template>
  <div v-if="projectId" class="project-page-nav d-flex align-center">
    <v-tooltip v-if="prevPage" :text="prevPage.label" location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          color="primary"
          variant="outlined"
          class="mr-2"
          @click="goTo(prevPage.route)"
        >
          <v-icon start>mdi-chevron-left</v-icon>
          {{ prevPage.label }}
        </v-btn>
      </template>
    </v-tooltip>
    <v-btn v-else color="primary" variant="outlined" class="mr-2" disabled>
      <v-icon start>mdi-chevron-left</v-icon>
      Zurück
    </v-btn>

    <v-tooltip v-if="nextPage" :text="nextPage.label" location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          color="primary"
          variant="outlined"
          class="mr-2"
          @click="goTo(nextPage.route)"
        >
          {{ nextPage.label }}
          <v-icon end>mdi-chevron-right</v-icon>
        </v-btn>
      </template>
    </v-tooltip>
    <v-btn v-else color="primary" variant="outlined" class="mr-2" disabled>
      Weiter
      <v-icon end>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { PROJECT_PAGES, projectPageIndex } from "@/config/projectPages";

const route = useRoute();
const router = useRouter();

const projectId = computed(() => route.params?.projectId);
const currentIndex = computed(() => projectPageIndex(route.name));

const prevPage = computed(() =>
  currentIndex.value > 0 ? PROJECT_PAGES[currentIndex.value - 1] : null,
);
const nextPage = computed(() =>
  currentIndex.value >= 0 && currentIndex.value < PROJECT_PAGES.length - 1
    ? PROJECT_PAGES[currentIndex.value + 1]
    : null,
);

function goTo(name: string) {
  router.push({ name, params: { projectId: projectId.value } });
}
</script>
